import HTTPClient, { HTTPClientParameters } from './HTTPClient';
import { DocumentUploadCategory, PropertyDocument } from 'types/Documents';

type DocumentsClientParams = HTTPClientParameters;

class DocumentsClient extends HTTPClient {
    constructor(params: DocumentsClientParams) {
        super(params);
    }

    getDocuments(spotUuid: string): Promise<PropertyDocument[]> {
        return this.get(`spots/${spotUuid}/documents`);
    }

    uploadDocuments(
        spotUuid: string,
        files: File[],
        categoryId: number
    ): Promise<Pick<PropertyDocument, 'display_name' | 'file_type' | 'id'>[]> {
        const formData = new FormData();
        files.forEach((file) => formData.append('file', file));
        return this.postForm(`spots/${spotUuid}/documents?category_id=${categoryId}`, formData);
    }

    getCategories(): Promise<DocumentUploadCategory[]> {
        return this.get('document-categories');
    }
}

export default DocumentsClient;
